import { registerSW } from "virtual:pwa-register";
import "./styles/index.css";
import { initApp } from "./app";

// PWA — let the plugin handle everything
registerSW({
  onOfflineReady() {},
});

initApp();
